import { clickButton } from '@plugins/biPoint/_configWebstoreV35';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import globalConfig from '@utiles/officialStore/globalConfig';
import bridge from '@utiles/officialStore/bridge';
import { isSafari } from '@utiles/officialStore/device';
import { mapState, mapGetters } from 'vuex';
const PAY_RESULT_TYPE = {
  SUCCESS: 'success',
  FAIL: 'fail',
  PENDING: 'pending',
  CANCEL: 'cancel'
};

export const CHECKOUT_MOUNT_SELECTOR = {
  FLOW: '#checkout-flow-container',
  CVV: '#checkout-cvv-container'
};

const CHECKOUT_ERROR_CODE = {
  COMPONENT_INVALID: 'component_invalid',
  PAYMENT_REQUEST_FAILED: 'payment_request_failed'
};

/** 应用语言 → Checkout locale（空字符串走 SDK 默认） */
const CHECKOUT_LOCALE_MAP = {
  'en-US': 'en',
  'zh-CN': 'zh',
  'zh-TW': 'zh-tw',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'de-DE': 'de',
  'es-ES': 'es',
  'fr-FR': 'fr',
  'pt-PT': 'pt',
  'vi-VN': 'vi',
  'it-IT': 'it',
  'ar-SA': 'ar'
};

const PAY_TYPE_INIT_CONFIG = {
  master: {
    createName: 'card',
    acceptedCardSchemes: ['mastercard']
  },
  visa: {
    createName: 'card',
    acceptedCardSchemes: ['visa']
  },
  applepay: {
    createName: 'applepay',
    acceptedCardSchemes: []
  },
  googlepay: {
    createName: 'googlepay',
    acceptedCardSchemes: []
  },
  jcb: {
    createName: 'card',
    acceptedCardSchemes: ['jcb']
  },
  amex: {
    createName: 'card',
    acceptedCardSchemes: ['american_express']
  }
};



export default {
  data() {
    return {
      showErrorPopup: false,
      errorMessage: '',
      cardCvvComponent: null,
      checkoutCvvLoading: false
    };
  },
  computed: {
    ...mapState({
      active_payway: state => state.cash.active_payway,
      payType: state => state.cash.pay_type,
      letter: state => state.letter
    }),
    ...mapGetters(['isSandBox'])
  },
  methods: {
    handleShowErrorPopup(message) {
      this.showErrorPopup = true;
      this.errorMessage = message;
    },
    handleErrorPopupClose() {
      this.showErrorPopup = false;
      this.errorMessage = '';
    },
    getCheckoutLocale() {
      return CHECKOUT_LOCALE_MAP[this.lang] || '';
    },
    getCheckoutAppearance() {
      const inSdk = bridge.runInsdk() || isSafari();
      const isSamsung = navigator.userAgent && /SM-/.test(navigator.userAgent)
      const isAndroid12 = navigator.userAgent && /Android 12/.test(navigator.userAgent)
      return {
        colorAction: '#00112c',
        colorPrimary: '#00112c',
        label: {
          fontWeight: 400,
          fontFamily: "tahoma, arial, 'Hiragino Sans GB', '\\5b8b\\4f53', sans-serif"
        },
        input: {
          fontSize: (inSdk && !isSamsung) || (inSdk && isAndroid12 && isSamsung) ? '30px' : ''
        }
      };
    },
    getCheckoutResultUrl(resultType, msg) {
      return `https://gstore.${globalConfig.getMainHost()}/checkout/online_callback/env/${this.config_key}?order_id=${this.order_id}&type=${resultType}&msg=${encodeURIComponent(
        msg
      )}`;
    },
    /**
     * 主支付流 onPaymentCompleted
     * @param {object} paymentResponse - Checkout 支付结果
     */
    handleCheckoutPaymentCompleted(paymentResponse) {
      window.location.href = this.getCheckoutResultUrl(
        PAY_RESULT_TYPE.SUCCESS,
        'success'
      );
    },
    /**
     * 主支付流 onError：先上报，再按错误码分支处理
     * @param {object} error - { code, message, ... }
     */
    handleCheckoutFlowError(error, jumpResultPage) {
      errorReport(ERROR_TYPE.CHECKOUT_SUBMIT_ERROR, {
        errorCode: error?.code || 'unknown error',
        errorMsg: error?.message || 'unknown error'
      });

      if (error?.code === CHECKOUT_ERROR_CODE.COMPONENT_INVALID) {
        return;
      }

      if (jumpResultPage) {
        window.location.href = this.getCheckoutResultUrl(
          PAY_RESULT_TYPE.FAIL,
          error?.message || ''
        );
      }
    },
    handleCheckoutSubmit() {
      clickButton({
        btnName: 'click-pay-btn'
      });
    },
    async initCheckoutFlow() {
      const payTypeConfig = PAY_TYPE_INIT_CONFIG[this.payType];
      if (!payTypeConfig) {
        errorReport(ERROR_TYPE.CHECKOUT_NO_PAY_TYPE, {
          payType: this.payType
        });
        return;
      }

      if (!this.payment_session || !this.public_key) {
        errorReport(ERROR_TYPE.CHECKOUT_INIT_PARAMS_ERROR, {
          payType: this.payType,
          hasPaymentSession: !!this.payment_session,
          hasPublicKey: !!this.public_key,
          type: 'checkout'
        });
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        return;
      }

      if (typeof CheckoutWebComponents !== 'function') {
        errorReport(ERROR_TYPE.CHECKOUT_INIT_ERROR, {
          payType: this.payType,
          error: 'CheckoutWebComponents is not available',
          type: 'checkout'
        });
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        return;
      }

      const checkoutAppearance = this.getCheckoutAppearance();
      const initCheckoutConfig = {
        paymentSession: this.payment_session,
        publicKey: this.public_key,
        environment: this.getCheckoutEnvironment(),
        locale: this.getCheckoutLocale(),
        appearance: {
          colorAction: checkoutAppearance.colorAction,
          input: checkoutAppearance.input
        },
        componentOptions: {
          [payTypeConfig.createName]: {
            acceptedCardSchemes: payTypeConfig.acceptedCardSchemes
          }
        },
        onPaymentCompleted: async (_self, paymentResponse) => {
          this.handleCheckoutPaymentCompleted(paymentResponse);
        },
        onError: async (self, error) => {
          // checkout人员建议，isValid=true才跳转结果页
          // isValid: 检查流程组件是否已捕获客户的所有详细信息，并且可以提交。
          if (
            self &&
            typeof self.isValid === 'function' &&
            self.isValid()
          ) {
            this.handleCheckoutFlowError(error, true);
          } else {
            this.handleCheckoutFlowError(error, false);
          }
        },
        onSubmit: () => {
          this.handleCheckoutSubmit();
        }
      };

      try {
        const checkout = await CheckoutWebComponents(initCheckoutConfig);
        const flowComponent = checkout.create(payTypeConfig.createName);
        const isAvailable = await flowComponent.isAvailable();

        if (isAvailable) {
          flowComponent.mount(CHECKOUT_MOUNT_SELECTOR.FLOW);
        } else {
          this.handleShowErrorPopup(this.letter.ckoNotAvailable);
          errorReport(ERROR_TYPE.CHECKOUT_PAY_TYPE_NOT_AVAILABLE, {
            payType: this.payType
          });
        }
      } catch (error) {
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        errorReport(ERROR_TYPE.CHECKOUT_INIT_ERROR, {
          payType: this.payType,
          error: error?.message || 'unknown error'
        });
      }
    },
    async initCheckoutCvv(nowPayway) {
      if (!this.public_key) {
        errorReport(ERROR_TYPE.CHECKOUT_INIT_PARAMS_ERROR, {
          payType: this.payType,
          hasPublicKey: !!this.public_key,
          type: 'card_cvv'
        });
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        this.checkoutCvvLoading = false;
        return;
      }

      if (typeof CheckoutWebComponents !== 'function') {
        errorReport(ERROR_TYPE.CHECKOUT_INIT_ERROR, {
          payType: this.payType,
          error: 'CheckoutWebComponents is not available',
          type: 'card_cvv'
        });
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        this.checkoutCvvLoading = false;
        return;
      }

      this.checkoutCvvLoading = true;

      try {
        const cvvCheckoutConfig = {
          publicKey: this.public_key,
          environment: this.getCheckoutEnvironment(),
          locale: this.getCheckoutLocale(),
          appearance: this.getCheckoutAppearance(),
          onReady: () => {
            this.checkoutCvvLoading = false;
          }
        };

        const checkout = await CheckoutWebComponents(cvvCheckoutConfig);
        const cardCvvComponent = checkout.create('card_cvv', {
          cardCvvLength: this.payType === 'amex' ? 4 : 3
        });
        const isAvailable = await cardCvvComponent.isAvailable();

        if (isAvailable) {
          cardCvvComponent.mount(CHECKOUT_MOUNT_SELECTOR.CVV);
          this.cardCvvComponent = cardCvvComponent;
        } else {
          this.checkoutCvvLoading = false;
          this.cardCvvComponent = null;
          this.handleShowErrorPopup(this.letter.ckoNotAvailable);
          errorReport(ERROR_TYPE.CHECKOUT_PAY_TYPE_NOT_AVAILABLE, {
            payType: this.payType,
            error: 'card_cvv is not available'
          });
        }
      } catch (error) {
        const errMsg = error?.message || '';
        const isBenignInitError =
          (errMsg.indexOf('element_not_found') !== -1 &&
            this.active_payway !== nowPayway) ||
          errMsg.indexOf('component_already_mounted') !== -1;
        if (isBenignInitError) {
          this.checkoutCvvLoading = false;
          return;
        }
        this.checkoutCvvLoading = false;
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        errorReport(ERROR_TYPE.CHECKOUT_INIT_ERROR, {
          payType: this.payType,
          error: error?.message || 'card_cvv init error'
        });
      }
    },
    async tokenizeCvv() {
      if (!this.cardCvvComponent) {
        return null;
      }
      try {
        const tokenizeRes = await this.cardCvvComponent.tokenize();
        if (!tokenizeRes) {
          return null;
        }
        return tokenizeRes?.data?.token || null;
      } catch (error) {
        this.handleShowErrorPopup(this.letter.ckoNotAvailable);
        errorReport(ERROR_TYPE.CHECKOUT_SUBMIT_ERROR, {
          errorCode: error?.code || 'cvv_tokenize_error',
          errorMsg: error?.message || 'unknown error'
        });
        return null;
      }
    },
    getCheckoutEnvironment() {
      return this.isSandBox ? 'sandbox' : 'production';
    }
  }
};
